import { ReactNode } from "react";

import { css } from "@compiled/react";
import { FormattedMessage } from "react-intl";

import { media } from "@atlaskit/primitives/responsive";

import { useLocalizedHref } from "@/libraries/web-framework";
import { Adg4CtaWithArrows } from "@/patterns/adg4/cta-with-arrows/cta-with-arrows";

export const CTASection = () => {
    return (
        <Adg4CtaWithArrows
            header={
                <FormattedMessage
                    id="CustomersLandingPage.cta.header"
                    defaultMessage="<startWriting>Start writing your <teamWorkStory>teamwork story</teamWorkStory> <gestureLines>today</gestureLines></startWriting>"
                    values={{
                        startWriting: (str: ReactNode) => (
                            <span className="h1 reduced-font-weight">
                                {str}
                            </span>
                        ),
                        teamWorkStory: (str: ReactNode) => (
                            <span className="h1">{str}</span>
                        ),
                        gestureLines: (str: ReactNode) => (
                            <span>
                                {str}
                                {/* eslint-disable-next-line no-restricted-syntax */}
                                <img
                                    css={customerStoryCTAGestureStyle}
                                    src="https://wac-cdn.atlassian.com/misc-assets/webp-images/yellow-gestural-lines-2995366884.webp"
                                    alt=""
                                />
                            </span>
                        )
                    }}
                />
            }
            ctaProps={{
                ctaText: (
                    <FormattedMessage
                        id="CustomersLandingPage.cta.buttonText"
                        defaultMessage="Become an advocate"
                    />
                ),
                href: useLocalizedHref("/advocacy"),
                dataEventProps: {
                    "data-event": "clicked",
                    "data-event-component": "linkButton",
                    "data-event-container": "ctaSection",
                    "data-product-key": "customers"
                }
            }}
        />
    );
};

const customerStoryCTAGestureStyle = css({
    position: "absolute",
    width: "55px",
    height: "55px",
    marginBlockStart: "-10px",
    marginInlineStart: "-10px",
    [media.only.md]: {
        width: "37px",
        height: "46px"
    },
    [media.only.sm]: {
        width: "27px",
        height: "36px"
    },
    [media.below.sm]: {
        width: "27px",
        height: "36px"
    }
});
